
  import moment from "moment";
  import PageDetailHeader from '@/components/core/PageDetailHeader';
  import locationModal from '@/components/modals/locationModal.vue';
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import ReviewCard2 from '@/components/ReviewSection/ReviewCard2'
  import loaderComponent from '@/components/loaderComponent'
  import RestaurantCard from '@/components/RestaurantCard'
  import CoolLightBox from "vue-cool-lightbox";
  import CheckoutModal from '@/components/modals/CheckoutModal';
  import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
  import FaqCardPost from "@/components/FaqCardPost";
  // import googleAd from '@/components/gAdUnitCode'
  export default {
    layout: 'detailsPage',
    scrollToTop: true,
    components: {
        PageDetailHeader,
        locationModal,
        VueSlickCarousel,
        ReviewCard2,
        loaderComponent,
        RestaurantCard,
        CoolLightBox,
        FaqCardPost,
        CheckoutModal
    },
    head() {
        return {
            title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
            meta: [{
                hid: 'description',
                name: 'description',
                content: this.metaDesc()
            },
            {
                hid: 'keywords',
                name: 'keywords',
                content: this.metaKeywords()
            },
            {
                hid: 'image',
                property: 'image',
                content: this.metaImage()
            },
            {
                hid: 'og:title',
                property: 'og:title',
                content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
            },
            {
                hid: 'og:image',
                property: 'og:image',
                content: this.metaImage()
            },
            {
              hid: 'og:image:secure_url',
              property: 'og:image:secure_url',
              content: this.metaImage()
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: this.metaDesc()
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
            },
            {
                hid: 'twitter:description',
                property: 'twitter:description',
                content: this.metaDesc()
            }
            ],
        }
    },
    jsonld() {
    if (!this.listings) {
        return null;
    }

    let structure = {
        '@context': 'https://schema.org',
    };

    let schemaData = [
        // ImageObject Schema
        {
            "@type": "ImageObject",
            "@id": this.metaImage(),
            "url": this.metaImage(),
            "contentUrl": this.metaImage(),
            "caption": this.listings && this.listings.post && this.listings.post.title
            ? this.listings.post.title
            : "Places in Goa App",
            "inLanguage": "en-US",
            "width": 1200,
            "height": 630
        },
        // WebPage Schema
        {
            "@type": "WebPage",
            "@id": `https://goa.app/service/${this.activitySlug}/#webpage`,
            "url": `https://goa.app/service/${this.activitySlug}`,
            "name": this.listings && this.listings.post && this.listings.post.title
                ? this.listings.post.title
                : 'Service Goa App',
            "description": this.listings && this.listings.post && this.listings.post.shortDescription
                ? this.listings.post.shortDescription
                : 'Service Goa App',
            "image": this.metaImage(),
            "inLanguage": 'en-US',
            "datePublished": this.listings && this.listings.post && this.listings.post.createdAt
                ? this.listings.post.createdAt
                : new Date(),
            "dateModified": this.listings && this.listings.post && this.listings.post.createdAt
                ? this.listings.post.createdAt
                : new Date(),
            "author": {
                "@type": "Person",
                "@id": "https://goa.app",
                "url": "https://goa.app"
            }
        },

        {
        "@type": "LocalBusiness",
        name:
          this.listings && this.listings.post && this.listings.post.title
            ? this.listings.post.title
            : "Services in Goa App",
        image:
          this.listings && this.listings.post && this.listings.post.gallery
            ? this.listings.post.gallery
            : [],
        geo: {
          "@type": "GeoCoordinates",
          latitude:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.latitude
              : "",
          longitude:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.longitude
              : "",
        },
        address: {
          "@type": "PostalAddress",
          streetAddress:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.address
              : "",
          addressLocality: this.listings && this.listings.post && this.listings.post.city && this.listings.post.city.area ? this.listings.post.city.area.name : "",
          addressCountry: "IN",
        },
        priceRange: "",
        review: {
          "@type": "Review",
          reviewRating: {
            "@type": "Rating",
            ratingValue:
              this.listings && this.listings.post && this.listings.post.rating
                ? this.listings.post.rating.averageRating
                : "5",
            bestRating:
              this.listings && this.listings.post && this.listings.post.rating
                ? this.listings.post.rating.averageRating
                : "5",
          },
          author: {
            "@type": "Person",
            name: "GoaApp",
          },
        },
        aggregateRating: {
          "@type": "AggregateRating",
          bestRating: "5",
          ratingCount: "169",
          ratingValue:
            this.listings && this.listings.post && this.listings.post.rating
              ? this.listings.post.rating.averageRating
              : "5",
          reviewCount:
            this.listings && this.listings.post && this.listings.post.views
              ? String(this.listings.post.views.count).slice(0, 2)
              : "5",
        },
      },

        {
  "@type": "Article",
  "@id": `https://goa.app/service/${this.listings && this.listings.post && this.listings.post.slug ? this.listings.post.slug : "" }`,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `https://goa.app/service/${this.listings && this.listings.post && this.listings.post.slug ? this.listings.post.slug : "" }`
  },
  "headline": this.listings && this.listings.post && this.listings.post.title 
              ? this.listings.post.title + " - Goa App" 
              : "Goa App",
  "name": this.listings && this.listings.post && this.listings.post.title 
          ? this.listings.post.title 
          : "Goa App",
  "description": this.metaDesc(),
  "keywords": this.metaKeywords(),
  "datePublished": this.listings && this.listings.post && this.listings.post.createdAt 
                   ? this.listings.post.createdAt 
                   : "Goa App",
  "dateModified": this.listings && this.listings.post && this.listings.post.updatedAt 
                  ? this.listings.post.updatedAt 
                  : "Goa App",
  "author": {
    "@type": "Person",
    "name": "Goa App",
    "url": "https://goa.app"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Goa App",
    "logo": {
      "@type": "ImageObject",
      "url": "https://goa.app/goa-app-logo.svg",
      "width": 317,
      "height": 207
    }
  },
  "image": {
    "@type": "ImageObject",
    "@id": this.metaImage(),
    "url": this.metaImage(),
    "width": 800,
    "height": 440
  }
}
    ];

    // For FAQ Schema
    let faqSchema = null;
    if (this.faqSchemaItems) {
      faqSchema = {
        "@type": "FAQPage",
        mainEntity: this.faqSchemaItems,
      };
      schemaData.push(faqSchema);
    }
    let ds = {
      "@graph": schemaData,
    };
    return { ...structure, ...ds };
},  
    data() {
        return {
            activitySlug: null,
            listings: null,
            relatedActivities: null,
            relatedPlaces: null,
            reviews: null,
            loading: true,
            offerLoading: true,
            listingLoading: true,
            touristDestSchema: [],
            faqSchemaItems: null,
            seoData: null,


            //new
            selectedSec: 'description',
            index: null,
            token: null,
        }
    },
    async validate({
        params,
        store
    }) {
        // await operations
        if (params.slug != (null || "")) {
            this.activitySlug = params.slug;
            return true // if the params are valid
        } else {
            return false // will stop Nuxt.js to render the route and display the error page
        }
    },
    created() {
        this.activitySlug = this.$route.params.slug;
        this.$fetch();
    },
    destroyed() {
        if (document.getElementById('placereviewClose'))
            document.getElementById('placereviewClose').click();
    },
    async fetch() {
        this.seoData = await fetch(this.$config.fetchUrl + '/api/posts/seo/getSEOContent/' + this.activitySlug)
            .then(res => res.json()).catch(error => {
                this.$router.push({
                    path: '/'
                })
                console.error("There was an error!", error); return false;
            });
    },
    mounted() {
        this.getPageData();
    },
    methods: {
        metaDesc() {
            if (this.seoData && this.seoData.description) {
                return this.seoData.description
            } else {
                return 'taxi service in goa, cab service in goa, escort service in goa, cheapest cab service in goa, online taxi service in goa, ambulance service in goa, transport services in goa, bus services in goa, saloon in goa, best spa in goa, spa in goa'
            }
        },
        metaKeywords() {
            if (this.seoData && this.seoData.keywords) {
                return this.seoData.keywords;
            } else {
                return 'taxi service in goa, cab service in goa, escort service in goa, cheapest cab service in goa, online taxi service in goa, ambulance service in goa, transport services in goa, bus services in goa, saloon in goa, best spa in goa, spa in goa'
            }
        },
        metaImage() {
            if (this.seoData && this.seoData.image) {
                return this.seoData.image;
            } else {
                return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
            }
        },

        async getPageData() {
                this.listings = await fetch(this.$config.fetchUrl + '/api/posts/app/getServiceBySlug/' + this.activitySlug)
                    .then(res => res.text()).catch(error => {
                        console.error("There was an error!", error); return false;
                    });
                this.$nextTick(() => {
                    this.populateData(this.listings);
                })

        },

        populateData(data) {
            this.listings = this.getCryptKey(data);
            this.$nextTick(() => {
                this.loading = false;
                this.offerLoading = false;
            })
        },

        getTermsArr(terms) {
            let arr = terms.split("\n")
            arr = arr.filter(item => item);
            return arr
        },


        async getAllData() {
            //Get the list of post data
            this.listings = await fetch(this.$config.fetchUrl + '/api/posts/app/getPostBySlug/' + this.activitySlug)
                .then(res => res.text()).catch(error => {
                    this.$router.push({
                        path: '/'
                    })
                    console.error("There was an error!", error); return false;
                });
            this.listings = this.getCryptKey(this.listings);

            //For FAQ schema start
      if (
        this.listings &&
        this.listings.post &&
        this.listings.post.faq &&
        this.listings.post.faq.length > 0
      ) {
        this.faqSchemaItems = this.listings.post.faq.map((item, index) => ({
          "@type": "Question",
          position: index + 1,
          name: item.title,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.description,
          },
        }));
      }
      //For FAQ schema end

            this.$nextTick(() => {
                this.loading = false;
                this.offerLoading = false;
            })
            this.relatedPlaces = await fetch(this.$config.fetchUrl + '/api/posts/app/getNearbyPlaces/' + this.activitySlug)
                .then(res => res.text())
            this.relatedPlaces = this.getCryptKey(this.relatedPlaces);
            this.relatedActivities = await fetch(this.$config.fetchUrl + '/api/posts/app/getNearbyActivities/' + this
                .activitySlug)
                .then(res => res.text())
            this.relatedActivities = this.getCryptKey(this.relatedActivities);
            this.touristDestSchema = this.relatedActivities.map(v => ({
                "@type": ["TouristAttraction"],
                "name": v.post && v.post.title ? v.post.title : 'Goa App',
                "image": v.post && v.post.gallery ? v.post.gallery : [],
                "sameAs": v.post && v.post.slug ? `https://goa.app/activities/${v.post.slug}` : 'Goa App'
            }));
            this.reviews = await fetch(this.$config.fetchUrl + '/api/posts/app/getReviews/' + this.activitySlug)
                .then(res => res.text())
            this.reviews = this.getCryptKey(this.reviews);
        },

        string_to_slug(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        // remove accents, swap ñ for n, etc
        var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaaeeeeiiiioooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes
        return str;
      },

        // To add a fallback placeholder image if not rendereds from API
        setFallbackImageUrl(event) {
            event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
        },

        getLatLongForMap() {
            if (this.listings.post && this.listings.post.location && this.listings.post.location.latitude && this.listings
                .post.location.longitude) {
                return this.listings.post.location.latitude + "," + this.listings.post.location.longitude
            }
            return ""
        },
        getGuidelineArr(guideline) {
            let arr = guideline.split("\n")
            arr = arr.filter(item => item);
            return arr
        },

        // Store filters in Localstorage
        scrollHere(item) {
            this.$nextTick(() => {
                this.scrollToJsOffers(item)
            })
        },

        goTotags(tag) {
        let tagSlug = this.string_to_slug(tag)
        this.$router.push({
          path: "/tags/" + tagSlug
        });
      },
    }
  }
  